import { useMemo } from "react";
import { useMapStore, useSaleCompStore } from "..";
import IEntityWithIcon from "../interfaces/IEntityWithIcon";
import ISaleComp from "../interfaces/ISaleComp";
import useSaleCompsWithGlobalFilters from "./useSaleCompsWithGlobalFilters";

export default function useRadiusSaleCompsOnMap(): ISaleCompWithIcon[] {
    const saleCompStore = useSaleCompStore();
    const mapStore = useMapStore();

    const radiusSaleComps = useMemo(() => {
        const radiusIdSet = new Set(saleCompStore.radiusSaleCompIds);
        return saleCompStore.saleComps.filter(sc => radiusIdSet.has(sc.id));
    }, [saleCompStore.saleComps, saleCompStore.radiusSaleCompIds]);

    const saleComps = useSaleCompsWithGlobalFilters(radiusSaleComps);

    return useMemo(() => saleComps.map(sc => {
        const icon = sc.pipedriveBuyerId && mapStore.loadedLogoCompanyIds.includes(sc.pipedriveBuyerId)
            ? `location-marker-company-${sc.pipedriveBuyerId}`
            : "sale-comp-marker";
        return { ...sc, icon };
    }), [saleComps, mapStore.loadedLogoCompanyIds]);
}

type ISaleCompWithIcon = ISaleComp & IEntityWithIcon
